import { render, staticRenderFns } from "./Forgetpwd.vue?vue&type=template&id=49cf5b06&scoped=true"
import script from "./Forgetpwd.vue?vue&type=script&lang=js"
export * from "./Forgetpwd.vue?vue&type=script&lang=js"
import style0 from "./Forgetpwd.vue?vue&type=style&index=0&id=49cf5b06&prod&lang=less"
import style1 from "./Forgetpwd.vue?vue&type=style&index=1&id=49cf5b06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cf5b06",
  null
  
)

export default component.exports